import { createContext } from 'react'

import type { Locale } from './locale'

export const LocaleContext = createContext<{
    locale: Locale
    changeLocale: (locale: Locale) => void
} | null>(null)
